import { stockApi } from '$api'
import { Recipe } from '@loadedhub/loaded-stock-api-sdk'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'

enum QueryKeys {
  GetAllRecipes = 'getAllRecipes',
}

/**
 * Retrieves all recipes
 * @param includeDeleted whether to include deleted recipes (defaults to false)
 * @returns a list of recipes
 */
export const getAllRecipes = async (
  includeDeleted: boolean = false
): Promise<Recipe[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.GetAllRecipes, includeDeleted],
    queryFn: async () => {
      return await stockApi.getRecipes(includeDeleted)
    },
  })
}
